/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class RequestTypeIds {
    static readonly newUserRequest: string = "498ec9be-9c4f-427f-84d7-8800a1095cab";
    static readonly newCarrierRequest: string = "2c837aa3-48a5-4a66-8a9f-a70d04d0a8b8";
    static readonly carrierReevaluation: string = "919d26db-ef18-4b81-bcbf-ee55ef4d564c";
    static readonly insuranceRenewal: string = "c905cd38-ff01-4e0c-84cc-87bd9b9e52d2";
}
